import Axios from 'axios';
import Config from "@/utils/config"
import { setupAxiosInterceptors } from './axios-interceptors';

import { Admin as AdminAPI } from "@upclaim/sdk"

const axios = Axios.create({
  baseURL: Config.API_URL,
  withCredentials: true,
});

setupAxiosInterceptors(axios);

const adminAPI = new AdminAPI();
adminAPI.instance = axios;

export default adminAPI;
